import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { AUCTION_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAuctionSocket'
import { singleAuctionQueryKey } from '@autobid/ui/composables/useAuction'
import { useQueryClient } from '@tanstack/vue-query'

export function useAuctionAuctionPublish() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const auctionPublish = () => {
    startListen({
      eventName: 'premium.AUCTION_PUBLISH',
      callbackName: AUCTION_SOCKET_CALLBACK,
      callback: (event) => {
        const queryKey = singleAuctionQueryKey.byAuctionId(event.context.auctionId)

        queryClient.invalidateQueries(queryKey)
      },
    })
  }

  return { auctionPublish }
}
